import AboutModal from './AboutModal';
export default AboutModal;
